const NS = 'IdsRemoveFilter';

export default function IdsRemoveFilter() {
  return function (array, removeIdsList) {
    if (!array || !array.length) {
      return [];
    }
    if (!removeIdsList || !removeIdsList.length) {
      return array;
    }
    const removeIds = removeIdsList.map(o => o._id);
    return array.filter(item => !removeIds.includes(item._id));
  };
}
